import * as angular from 'angular';

import AuthDataServiceName, {AuthDataService} from "../auth/authData.service";

export default angular.module('aps.interceptors', [AuthDataServiceName])
  .factory('httpInterceptors',
    function($q: angular.IQService,
             $location: angular.ILocationService,
             authDataService: AuthDataService) {
      return {
        'request': function(config) {
          let userId = authDataService.getUserId();
          if (!userId) {
            userId = $location.search().userId;
            if (userId) {
              authDataService.setUserId(userId);
            }
          }

          let token = authDataService.getToken();
          if (token) {
            config.headers.Authorization = 'Bearer ' + token;
          }
          return config;
        },
        'responseError': function(response) {
          if (response.status === 401) {
            authDataService.clearToken();
            $location.url('/signIn');
          }
          return $q.reject(response);
        }
      };
    })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/http/http.interceptors.ts